/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toAdmissionProps, toCheckInRequest, toCheckOutRequest, toAdmissionRequest } from './translator/admission'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchAdmission, CheckIn, CheckOut, PatchAdmission } from '@/infrastructure/network/Monitaro/requests/admission'
import { IAdmissionProps } from '@/entities/Admission'

export default class Admission extends MonitaroGatewayBase {
  async FetchAdmission(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchAdmission(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.admissions.map((prop) => toAdmissionProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async CheckIn(area: string, params: IAdmissionProps) {
    const { admission } = await this.apiClient.request(new CheckIn(area, toCheckInRequest(params)))
    return toAdmissionProps(admission)
  }

  async CheckOut(area: string, params: IAdmissionProps) {
    const { admission } = await this.apiClient.request(new CheckOut(area, toCheckOutRequest(params)))
    return toAdmissionProps(admission)
  }

  async PatchAdmission(id: string, params: IAdmissionProps) {
    const { admission } = await this.apiClient.request(new PatchAdmission(id, toAdmissionRequest(params)))
    return toAdmissionProps(admission)
  }
}
